<template>
	<div>
        <div class="pt-2 flex justify-center space-x-2">
            <div @click.prevent="toggleFavorite(comp)" :class="buttonClasses">
                <inline-svg
                	name="favorite"
                	:class="comp.pivot.is_favorite ? 'text-red-600 hover:text-red-700' : 'text-gray-400 hover:text-red-600'"
                	classes="w-full h-full cursor-pointer"
                ></inline-svg>
            </div>
            <div @click.prevent="toggleRejected(comp)" :class="buttonClasses">
                <inline-svg
                	name="rejected"
                	:class="comp.pivot.is_rejected ? 'text-red-600 hover:text-red-700' : 'text-gray-400 hover:text-red-600'"
                	classes="w-full h-full cursor-pointer"
                ></inline-svg>
            </div>
            
            <div class="mt-0.5" v-if="$gate.isAdmin()" :title="getResearchStatusTitle(comp)">
                <v-popover trigger="click" offset="10" ref="popover">
	                <inline-svg :name="comp.pivot.research_status" classes="w-7 h-7 text-blue-500 hover:text-blue-600 cursor-pointer fill-current"></inline-svg>

                    <template slot="popover">
                        <p class="w-10/12 text-center mt-4 mx-auto">Change the <strong>Research Status</strong> by clicking below</p>
                        <div class="leading-normal max-w-sm p-6">
                             <div
                                class="flex items-center p-4 mb-4 border border-gray-300 hover:bg-gray-200 cursor-pointer rounded"
                                :class="comp.pivot.research_status == 'not-researched' ? 'bg-yellow-100' : 'bg-white'"
                                @click.prevent="changeResearchStatus(comp, 'not-researched')">
                                    <inline-svg name="not-researched"></inline-svg>
                                    <span class="ml-2">Not Researched</span>
                            </div>
                             <div
                                class="flex items-center p-4 mb-4 border border-gray-300 hover:bg-gray-200 cursor-pointer rounded"
                                :class="comp.pivot.research_status == 'researching' ? 'bg-yellow-100' : 'bg-white'"
                                @click.prevent="changeResearchStatus(comp, 'researching')">
                                    <inline-svg name="researching"></inline-svg>
                                    <span class="ml-2">Researching</span>
                            </div>
                             <div
                                class="flex items-center p-4 mb-4 border border-gray-300 hover:bg-gray-200 cursor-pointer rounded"
                                :class="comp.pivot.research_status == 'research-complete' ? 'bg-yellow-100' : 'bg-white'"
                                @click.prevent="changeResearchStatus(comp, 'research-complete')">
                                    <inline-svg name="research-complete"></inline-svg>
                                    <span class="ml-2">Research Complete</span>
                            </div>
                        </div>
                    </template>
                </v-popover>
            </div>
            <div v-else class="mt-0.5" :class="buttonClasses" :title="getResearchStatusTitle(comp)">
                <inline-svg
                	:name="comp.pivot.research_status"
                	classes="w-7 h-7 text-blue-500 fill-current"
                ></inline-svg>
            </div>                                    
        </div>
	</div>
</template>

<script>
    import moment from 'moment';
    
    export default {
        props: {
            compData: {
              type: [Array, Object],
              required: true
            },

            buttonClasses: {
            	type: String,
            	default: "w-8 h-8"
            }
        },

        data() {
        	return {
        		comp: this.compData
        	}
        },

        methods: {
            getResearchStatusTitle(comp) {
                return comp.pivot.research_status.replace(/-/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
            },

            toggleFavorite(comp) {
                this.updateComp(comp, {
                    favorited_at: comp.pivot.is_favorite ? null : moment().format('Y-MM-D H:m:ss'),
                    favorited_by: comp.pivot.is_favorite ? null : window.user.id
                });
            },

            toggleRejected(comp) {
                this.updateComp(comp, {
                    rejected_at: comp.pivot.is_rejected ? null : moment().format('Y-MM-D H:m:ss'),
                    rejected_by: comp.pivot.is_rejected ? null : window.user.id
                });
            },

            changeResearchStatus(comp, status) {
                this.updateComp(comp, {
                    research_status: status
                });

                this.$refs.popover.isOpen = false;
            },

            updateComp(comp, params) {
                axios.patch('/projects/' + comp.pivot.project_id + '/comps/' + comp.pivot.id, params)
                    .then((response) => {
                        comp.pivot = response.data.comp;

                        this.$notify({
                            type: 'success',
                            title: 'Success',
                            text: response.data.message
                        }); 
                    }).catch((response) => {
                        this.$notify({
                            type: 'error',
                            title: 'Error',
                            text: response.data.message
                        }); 
                    });
            }
        }
    }
</script>